<template>
  <main class="map-page">
    <!-- Menú lateral -->
    <NavDrawer />

    <!-- Mapa principal -->
    <MapView ref="mapView" />

    <!-- Herramienta de selección: siempre montada, visible por Vuex state -->
    <SelectTool />

    <!-- Contenedores de herramientas dinámicas -->
    <ToolContainer />
    <!-- Contenedores de datos dinámicos -->
    <DataContainer />

    <!-- Controles custom del mapa -->
    <MapControlsCustom />

    <!-- Toast Notification System -->
    <ToastNotification />
  </main>
</template>

<script>
// Servicios del mapa
import { mapService } from '@/services/map/mapService'
import { mapControlsService } from '@/services/map/mapControlsService'

// Componentes
import SelectTool from '@/components/mapTools/select/Select.vue'
import MapView from '@/components/MapView.vue'
import MapControlsCustom from '@/components/mapControls/MapControlsCustom.vue'
import NavDrawer from '@/components/mapControls/NavDrawer.vue'
import ToolContainer from '@/components/mapTools/ToolContainer.vue'
import DataContainer from '@/components/mapTools/DataContainer.vue'
import ToastNotification from '@/components/common/ToastNotification.vue'


export default {
  name: 'MapContainer',

  components: {
    MapView,
    MapControlsCustom,
    NavDrawer,
    ToolContainer,
    DataContainer,
    SelectTool,
    ToastNotification,
  },

  mounted() {
    // Configurar controles nativos del mapa (OverviewMap, ScaleLine)
    const map = mapService.get();
    if (map) {
      mapControlsService.addDefaultControls(map);
    }
  },

  beforeDestroy() {
    // Limpiar el mapa al salir
    mapService.destroy();
  }
};
</script>

<style lang="scss" scoped>
.map-page {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  background: rgb(0, 111, 179);
  overflow: hidden;
  z-index: 1000;
}
</style>
